/* =========================================================
   SHIZOKU — interactions
   ========================================================= */
(() => {
  const root = document.documentElement;
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ---------- Échelle : on retire la largeur de la scrollbar ---------- */
  // (borné à 0–30px : sur mobile innerWidth peut différer fortement de clientWidth)
  const setScrollbar = () => {
    const sbw = Math.min(30, Math.max(0, window.innerWidth - root.clientWidth));
    root.style.setProperty('--sbw', `${sbw}px`);
  };
  setScrollbar();
  window.addEventListener('resize', setScrollbar);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const KATAKANA = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲンガギグゲゴザジズゼゾバビブベボパピプペポ';
  const randomKana = () => KATAKANA[Math.floor(Math.random() * KATAKANA.length)];

  /* ---------- Titres : brouillage en katakana puis lettre finale ---------- */
  const SCRAMBLE_SEL = '.title-40, .quiz-teaser__title, .characters__title, .product-title, .quiz__title, .quiz__play, .footer__h';

  // découpe le texte en <span class="scr"> (un par lettre), regroupés par mot pour ne pas couper les mots
  const prepareScramble = (el) => {
    if (el.dataset.scrReady) return;
    el.dataset.scrReady = '1';
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const frag = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach((part) => {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        const word = document.createElement('span');
        word.className = 'scr-w';
        word.setAttribute('aria-hidden', 'true');
        for (const ch of part) {
          const s = document.createElement('span');
          s.className = 'scr';
          s.textContent = ch;
          word.appendChild(s);
        }
        frag.appendChild(word);
      });
      node.replaceWith(frag);
    });
  };

  const playScramble = (el) => {
    prepareScramble(el);
    el.classList.remove('scr-wait');
    if (reducedMotion) return;
    cancelAnimationFrame(el._scrRaf);
    el.style.setProperty('--scr-c', getComputedStyle(el).color);
    const chars = $$('.scr', el);
    const stagger = Math.min(26, 700 / Math.max(chars.length, 1));
    // chaque lettre : invisible → katakana qui changent vite → lettre finale
    const plan = chars.map((s, i) => {
      const start = i * stagger + Math.random() * 40;
      return { s, start, end: start + 160 + Math.random() * 200, last: -1 };
    });
    const t0 = performance.now();
    const tick = (now) => {
      const t = now - t0;
      let done = 0;
      plan.forEach((p) => {
        if (t >= p.end) {
          if (p.state !== 'done') { p.s.classList.remove('is-k'); p.s.style.opacity = ''; p.state = 'done'; }
          done += 1;
        } else if (t >= p.start) {
          if (p.state !== 'k') { p.s.classList.add('is-k'); p.s.style.opacity = ''; p.state = 'k'; }
          if (t - p.last > 55) { p.s.dataset.k = randomKana(); p.last = t; }
        } else if (p.state !== 'wait') {
          p.s.style.opacity = '0'; p.state = 'wait';
        }
      });
      if (done < plan.length) el._scrRaf = requestAnimationFrame(tick);
    };
    el._scrRaf = requestAnimationFrame(tick);
  };

  const scrambleEls = $$(SCRAMBLE_SEL);
  scrambleEls.forEach((el) => {
    prepareScramble(el);
    el.classList.add('scr-wait');
    // on rejoue l'effet au survol, comme dans le menu
    el.addEventListener('mouseenter', () => { if (!el.classList.contains('scr-wait')) playScramble(el); });
  });

  /* ---------- Chargement + transitions : le bulldog court après la mouche ---------- */
  const loader = $('[data-loader]');
  const runner = $('[data-runner]');
  const store = (fn) => { try { return fn(sessionStorage); } catch { return null; } };

  let markReady;
  const pageReady = new Promise((resolve) => { markReady = resolve; });

  const run = (cls) => {
    if (!runner) return;
    runner.classList.remove('run-across', 'run-in', 'run-out');
    void runner.offsetWidth; // relance l'animation
    runner.classList.add(cls);
  };

  const hideLoader = () => {
    store((s) => s.setItem('shizoku-visited', '1'));
    root.classList.add('is-ready');
    if (loader) { loader.classList.remove('is-active'); loader.classList.add('is-done'); }
    // après le fondu, les prochaines transitions utilisent le voile translucide
    setTimeout(() => root.classList.remove('first-load', 'from-transition'), 450);
    markReady();
  };

  const domReady = Promise.all([document.fonts ? document.fonts.ready : null]);
  const timeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  if (!loader || reducedMotion) {
    hideLoader();
  } else if (root.classList.contains('first-load')) {
    // 1re visite : fond blanc, le chien traverse l'écran (2 s), sans attendre les grosses photos
    run('run-across');
    Promise.all([timeout(1900), Promise.race([domReady, timeout(2500)])]).then(hideLoader);
  } else if (root.classList.contains('from-transition')) {
    // arrivée après un clic : le chien repart du centre et sort à droite par-dessus la nouvelle page
    run('run-out');
    timeout(650).then(hideLoader);
  } else {
    hideLoader();
  }

  // navigation interne : le chien entre en courant jusqu'au centre, puis on change de page
  const navigate = (href) => {
    if (!loader || reducedMotion) { location.href = href; return; }
    store((s) => s.setItem('shizoku-transition', '1'));
    loader.classList.remove('is-done');
    loader.classList.add('is-active');
    run('run-in');
    setTimeout(() => { location.href = href; }, 650);
  };

  window.addEventListener('pageshow', (e) => {
    if (e.persisted && loader) { loader.classList.remove('is-active'); loader.classList.add('is-done'); }
  });

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href]');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    const href = a.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('mailto:')) return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.hash) return;
    e.preventDefault();
    navigate(a.href);
  });

  /* ---------- Images : fondu au chargement ---------- */
  $$('.media > img').forEach((img) => {
    if (img.complete) return;
    img.classList.add('is-loading');
    img.addEventListener('load', () => img.classList.remove('is-loading'), { once: true });
    img.addEventListener('error', () => img.classList.remove('is-loading'), { once: true });
  });

  // les 2e photos des cartes sont décodées à l'avance pour un survol sans à-coup
  pageReady.then(() => {
    const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 300));
    idle(() => $$('.card__hover').forEach((img) => {
      img.loading = 'eager';
      if (img.decode) img.decode().catch(() => {});
    }));
  });

  /* ---------- Apparition au scroll (démarre quand le rideau est levé) ---------- */
  const revealEls = $$('[data-reveal]');
  pageReady.then(() => {
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach((el) => el.classList.add('is-visible'));
      scrambleEls.forEach((el) => { if (el.classList.contains('scr-wait')) playScramble(el); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach((el) => io.observe(el));

    // brouillage des titres quand ils arrivent à l'écran (avec le même délai que leur apparition)
    const sio = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        sio.unobserve(el);
        const holder = el.closest('[data-reveal]') || el;
        const delay = parseFloat(getComputedStyle(holder).getPropertyValue('--d')) || 0;
        setTimeout(() => playScramble(el), 120 + delay * 1000);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    scrambleEls.forEach((el) => { if (el.classList.contains('scr-wait')) sio.observe(el); });
  });

  /* ---------- Fiche produit : en-tête fixe en négatif au-dessus des photos ---------- */
  const negativeEls = $$('.site-header--product .header-logo, .site-header--product .nav-link');
  if (negativeEls.length) {
    let ticking = false;
    const isOverPhoto = (el) => {
      const r = el.getBoundingClientRect();
      // on teste plusieurs points de l'élément : il passe en blanc dès que la majorité est sur une photo
      const points = [[.5, .5], [.2, .5], [.8, .5]];
      const hits = points.filter(([px, py]) => document
        .elementsFromPoint(r.left + r.width * px, r.top + r.height * py)
        .some((node) => node.classList && node.classList.contains('media')));
      return hits.length >= 2;
    };
    const update = () => {
      ticking = false;
      negativeEls.forEach((el) => el.classList.toggle('is-negative', isOverPhoto(el)));
    };
    const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  }

  /* ---------- Panneaux : menu + panier ---------- */
  const backdrop = $('[data-backdrop]');
  const menu = $('#menu');
  const cart = $('#cart');
  let openPanel = null;

  const closePanels = () => {
    [menu, cart].forEach((p) => p && p.classList.remove('is-open'));
    [menu, cart].forEach((p) => p && p.setAttribute('aria-hidden', 'true'));
    $$('[data-menu-open], [data-cart-open]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    backdrop && backdrop.classList.remove('is-active');
    openPanel = null;
  };

  const open = (panel, trigger) => {
    if (!panel) return;
    if (openPanel === panel) { closePanels(); return; }
    closePanels();
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    trigger && trigger.setAttribute('aria-expanded', 'true');
    backdrop && backdrop.classList.add('is-active');
    openPanel = panel;
  };

  $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => open(menu, b)));
  $$('[data-cart-open]').forEach((b) => b.addEventListener('click', () => open(cart, b)));
  backdrop && backdrop.addEventListener('click', closePanels);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanels(); });

  /* ---------- Menu : HOME / STORE se brouillent en japonais au survol ---------- */
  const scramble = (el, target) => {
    cancelAnimationFrame(el._scrambleRaf);
    const from = el.textContent;
    const length = Math.max(from.length, target.length);
    // chaque lettre commence à se brouiller puis se fixe à un moment aléatoire (≈ 0,3 s au total)
    const queue = Array.from({ length }, (_, i) => {
      const start = Math.random() * 100;
      return { from: from[i] || '', to: target[i] || '', start, end: start + 100 + Math.random() * 130 };
    });
    const t0 = performance.now();
    const tick = (now = performance.now()) => {
      const elapsed = now - t0;
      let done = 0;
      el.textContent = queue.map((q) => {
        if (elapsed >= q.end) { done += 1; return q.to; }
        if (elapsed >= q.start) return randomKana();
        return q.from;
      }).join('');
      if (done < queue.length) el._scrambleRaf = requestAnimationFrame(tick);
    };
    tick();
  };

  $$('[data-jp]').forEach((link) => {
    const latin = link.textContent.trim();
    const jp = link.dataset.jp;
    const toJp = () => scramble(link, jp);
    const toLatin = () => scramble(link, latin);
    link.addEventListener('mouseenter', toJp);
    link.addEventListener('focus', toJp);
    link.addEventListener('mouseleave', toLatin);
    link.addEventListener('blur', toLatin);
  });

  /* ---------- Panier Shopify (API AJAX : /cart.js, /cart/add.js, /cart/change.js) ---------- */
  const SHZ = window.SHZ || {};
  const routes = SHZ.routes || {};
  const cartUrl = (path) => `${(routes.root || '/').replace(/\/$/, '')}${path}`;
  let cartState = { item_count: 0, items: [], total_price: 0 };

  const formatPrice = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')} EUR`;

  const cartRequest = (path, body) => fetch(cartUrl(path), {
    method: body ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
  }).then((r) => r.json().then((data) => (r.ok ? data : Promise.reject(data))));

  const itemImage = (item) => {
    const fallback = (SHZ.fallbackImages || {})[item.handle];
    if (fallback) return fallback;
    return item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=300` : '';
  };

  const renderCart = (bump = false) => {
    const count = cartState.item_count || 0;
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
    if (bump) {
      const badge = $('.cart-count');
      if (badge) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }
    }
    const list = $('[data-cart-items]');
    const empty = $('[data-cart-empty]');
    const total = $('[data-cart-total]');
    const cta = $('[data-cart-cta]');
    if (!list) return;

    list.innerHTML = '';
    cartState.items.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'cart-item';
      li.innerHTML = `
        <div class="cart-item__img"><img src="" alt=""></div>
        <div>
          <p class="cart-item__name"></p>
          <p class="cart-item__meta"></p>
          <div class="cart-item__qty">
            <button type="button" data-qty="-1" aria-label="Retirer un">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-qty="1" aria-label="Ajouter un">+</button>
          </div>
        </div>
        <button type="button" class="cart-item__remove">Retirer</button>`;
      const img = $('.cart-item__img img', li);
      const src = itemImage(item);
      if (src) img.src = src; else img.remove();
      const size = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      $('.cart-item__name', li).textContent = item.product_title;
      $('.cart-item__meta', li).textContent = `${size ? `Taille ${size} · ` : ''}${formatPrice(item.final_price)}`;
      const change = (quantity) => cartRequest('/cart/change.js', { id: item.key, quantity })
        .then((cart) => { cartState = cart; renderCart(); })
        .catch(() => {});
      $$('[data-qty]', li).forEach((b) => b.addEventListener('click', () => change(Math.max(0, item.quantity + Number(b.dataset.qty)))));
      $('.cart-item__remove', li).addEventListener('click', () => change(0));
      list.appendChild(li);
    });

    const hasItems = cartState.items.length > 0;
    if (empty) empty.hidden = hasItems;
    if (total) {
      total.hidden = !hasItems;
      total.textContent = `Total : ${formatPrice(cartState.total_price)}`;
    }
    if (cta) {
      cta.textContent = hasItems ? 'Checkout' : 'Explore products';
      cta.setAttribute('href', hasItems ? (routes.checkout || '/checkout') : (routes.shop || '/collections/all'));
    }
  };

  const refreshCart = (bump = false) => cartRequest('/cart.js')
    .then((cart) => { cartState = cart; renderCart(bump); })
    .catch(() => {});

  // ajoute la variante (id Shopify) puis ouvre le panier ; renvoie false si l'ajout échoue
  const addToCart = (variantId) => cartRequest('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
    .then(() => refreshCart(true))
    .then(() => { if (openPanel !== cart) open(cart, $('[data-cart-open]')); return true; })
    .catch(() => false);

  refreshCart();
  // retour arrière depuis le paiement : le panier peut avoir changé
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  // Bouton "+" des cartes produit (ajoute la taille M, ou la 1re taille disponible)
  $$('[data-add]').forEach((btn) => btn.addEventListener('click', (e) => {
    e.preventDefault();
    const variant = btn.dataset.variant;
    const link = btn.closest('.card')?.querySelector('.card__link');
    if (!variant) { if (link) navigate(link.href); return; }
    btn.classList.add('is-added');
    setTimeout(() => btn.classList.remove('is-added'), 700);
    addToCart(variant).then((ok) => { if (!ok && link) navigate(link.href); });
  }));

  /* ---------- Fiche produit : tailles + BUY ---------- */
  const sizes = $('[data-sizes]');
  let selectedVariant = null;
  if (sizes) {
    $$('.size', sizes).forEach((btn) => btn.addEventListener('click', () => {
      $$('.size', sizes).forEach((b) => { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      selectedVariant = btn.dataset.variant || null;
      const msg = $('[data-buy-msg]');
      msg && msg.classList.remove('is-visible');
    }));
  }

  const buyBtn = $('[data-buy]');
  if (buyBtn) {
    buyBtn.addEventListener('click', () => {
      const msg = $('[data-buy-msg]');
      const single = buyBtn.dataset.variant; // produit sans tailles
      const variant = selectedVariant || single;
      if (!variant) {
        if (sizes) { sizes.classList.remove('shake'); void sizes.offsetWidth; sizes.classList.add('shake'); }
        if (msg) { msg.textContent = 'Choisis une taille'; msg.classList.add('is-visible'); }
        return;
      }
      addToCart(variant).then((ok) => {
        if (!ok && msg) { msg.textContent = 'Taille indisponible'; msg.classList.add('is-visible'); }
      });
    });
  }

  /* ---------- Fiche produit (mobile) : photos en slide + points ---------- */
  const gallery = $('.product-gallery');
  const slides = gallery ? $$('.gallery-item', gallery) : [];
  if (slides.length > 1) {
    const dots = document.createElement('div');
    dots.className = 'gallery-dots';
    dots.setAttribute('aria-label', 'Photos');
    slides.forEach((slide, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', `Photo ${i + 1}`);
      b.addEventListener('click', () => gallery.scrollTo({ left: slide.offsetLeft - gallery.offsetLeft - parseFloat(getComputedStyle(gallery).paddingLeft), behavior: 'smooth' }));
      dots.appendChild(b);
    });
    gallery.after(dots);
    const setActive = () => {
      const i = Math.round(gallery.scrollLeft / (gallery.scrollWidth / slides.length));
      $$('button', dots).forEach((b, j) => b.classList.toggle('is-active', j === Math.min(i, slides.length - 1)));
    };
    gallery.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
    setActive();
  }

  /* ---------- Accordéon ---------- */
  $$('.acc-item').forEach((item) => {
    const head = $('.acc-head', item);
    head.addEventListener('click', () => {
      const isOpen = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', String(isOpen));
    });
  });

  /* ---------- Carrousel d'avis ---------- */
  const reviews = $$('.review');
  if (reviews.length) {
    let current = 0;
    let timer;
    const show = (next, dir = 1) => {
      if (next === current) return;
      const prev = reviews[current];
      prev.classList.toggle('is-leaving-left', dir > 0);
      prev.classList.remove('is-active');
      setTimeout(() => prev.classList.remove('is-leaving-left'), 800);
      current = (next + reviews.length) % reviews.length;
      reviews[current].classList.add('is-active');
    };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(current + 1, 1), 6000); };
    $('[data-review-prev]')?.addEventListener('click', () => { show(current - 1, -1); auto(); });
    $('[data-review-next]')?.addEventListener('click', () => { show(current + 1, 1); auto(); });
    auto();
  }

  /* ---------- Newsletter : le formulaire client Shopify est envoyé normalement (message affiché au retour) ---------- */

  /* ---------- Quiz ---------- */
  const QUIZ_KEY = 'shizoku-quiz';
  const readQuiz = () => {
    try { return JSON.parse(sessionStorage.getItem(QUIZ_KEY)) || { answers: [] }; } catch { return { answers: [] }; }
  };
  const writeQuiz = (data) => {
    try { sessionStorage.setItem(QUIZ_KEY, JSON.stringify(data)); } catch { /* stockage indisponible */ }
  };

  const go = navigate;

  const quizForm = $('[data-quiz-start]');
  if (quizForm) {
    quizForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const name = $('input', quizForm).value.trim();
      writeQuiz({ name, answers: [] });
      go(quizForm.getAttribute('action'));
    });
  }

  const answers = $$('[data-answer]');
  if (answers.length) {
    const step = Number($('.quiz').dataset.step);
    answers.forEach((btn) => btn.addEventListener('click', () => {
      if (btn.classList.contains('is-picked')) return;
      btn.classList.add('is-picked');
      const data = readQuiz();
      data.answers[step - 1] = btn.dataset.answer;
      writeQuiz(data);
      const next = $('.quiz').dataset.next;
      if (next) { setTimeout(() => go(next), 450); return; }

      // Fin du quiz
      const toast = $('[data-toast]');
      if (toast) {
        const who = data.name ? `Merci ${data.name} !` : 'Merci !';
        $('[data-toast-title]', toast).textContent = who;
        toast.classList.add('is-visible');
      }
      setTimeout(() => go(cartUrl('/#characters')), 2600);
    }));
  }
})();
